import React, { useEffect, useState } from 'react'
import { getSubscriptionPlans } from './api'
import { updateSelectedPlans } from '../helper'
import VLPlayerCore from '@viewlift/player-backup/esm/index';
import PlansList from './PlansList'
import "./style.scss"
import { getFontsStyles } from '../../modules/TrayModules/Helper/helper'
import { publishAppLoading, publishErrorUpdate, publishRedirect } from '../Events/utils.events'
import { publishPlansLoaded, subscribeGetContentEntitlementPlans, subscribeUpdateMonetizationCta } from '../Events/plans.events'
import { fetchCurrentPlan, fetchTveLoggedIn, formulateAllPlanIds, fromulatePlanIds, structuredPlan } from './helper'
import { publishMorePurchaseList } from '../Events/monetisation.events'
import { getPlanIdFromQueryParams } from '../Viewplans02/helper'
import { getPlansById } from '../Viewplans02/api'
import { fetchCheckoutStore } from '../utils/CheckoutStore'
import localforage from 'localforage'
import { getToken, handleSeviceTypes } from '../../helpers'
import { parseJSON } from '../utils/parseJSON';

const PlansWrapper = (props) => {
  let metadataMap = props?.moduleData?.metadataMap
  let contentData = props?.moduleData?.contentData?.length ? props?.moduleData?.contentData[0] : null
  let checkoutModuleData = props?.checkoutModuleData
  let checkoutSettings = checkoutModuleData?.layout?.settings
  let moneisationCta = props?.monetisationCta
  let isVideoPage = props?.isVideoPage || false
  let isSeriesPage = props?.isSeriesPage || false
  let videoData = props?.videoData
  let contentPlans = videoData ? videoData?.plans : props?.moduleData?.plans
  let layoutSettings = props?.checkoutModuleData?.layout?.settings
  let isTveLoggedIn = props?.isTveLoggedIn || false
  const { popupHeadingTitleFont, popupCtaTitleFont, popupCtaSubTitleFont, popupPriceFont, popupDetailFont, ctaHeadingStyles, featureItemStyles,
    planBannerHeadingStyles,planBannerSubHeadingStyles,planBannerPriceStyles } = getFontsStyles(props?.moduleData?.layout?.fontSetting || props?.checkoutModuleData?.layout?.fontSetting)
  let subscriptionPopupFonts = { popupHeadingTitleFont, popupCtaTitleFont, popupCtaSubTitleFont, popupPriceFont, popupDetailFont,ctaHeadingStyles, featureItemStyles,  planBannerHeadingStyles,planBannerSubHeadingStyles,planBannerPriceStyles }
  // let isTvePlan = contentData?.plans?.filter((plan) => plan?.type === "TVE")?.length || false
  const [plans, setPlans] = useState([])
  let isTVEEnabled = JSON.parse(sessionStorage.getItem('toShowTve')) // handles for non V2 supported contents
  let isTveContent = (videoData || contentData)?.plans?.filter((plan) => plan?.type === "TVE")?.length && !isTveLoggedIn ? true : false
  const [isTvePlan,setIsTvePlan] = useState(isTveContent)
  const [contentEntitlementPlans,setContentEntitlementPlans] = useState([])
  const [isEntitlementDataFetched,setIsEntitlementDataFetched] = useState(false)
  const [tveSubscribedError,setTveSubscribedError] = useState(false)

  const tvePlanDetails = ({metadataMap,subscriptionPopupFonts}) => {
    let tvePlan = {
      title: metadataMap?.loginCtaTveProvideTitle || "Login with TVE",
      subTitle: metadataMap?.loginCtaTveProviderDescription || "Free access with your TV credentials",
      type: "TVE",
      subscriptionPopupFonts,
      planId: "TVE"
    }
    return tvePlan
  }

const handleTvePlanInsertion = () => {
  let servicetypes = handleSeviceTypes()
  if(servicetypes?.TVE && (props?.isCheckout || isTveContent)) {
    setIsTvePlan(true)
    isTveContent = true //overide 
  }
  if(servicetypes?.TVE && isTVEEnabled != null && isTVEEnabled != undefined && !isTVEEnabled) setIsTvePlan(false) //overide 
}

const isTveRegistered = () => {
  const currentQueryParams = window?.location?.search || "";
  const params = new URLSearchParams(currentQueryParams);
  return params.get("user") === "registered";
}
const findIsOnlyTve = (plans,isTveLoggedIn,isTveContent) => {
    let monetizationModals = plans?.map((plan) => plan?.monetizationModel)
    if(isTveContent && isTveLoggedIn) {
        isTveContent = false
        setIsTvePlan(false)
        if (monetizationModals.length === 1) return true
    }
    return false
}

  const fetchPlans = async () => {
    // fetching plans
    try {
    let isTveLoggedIn = await fetchTveLoggedIn()
    let plans = contentEntitlementPlans?.length ? contentEntitlementPlans : contentPlans
    let isUnmatchedTvePlan = findIsOnlyTve(plans,isTveLoggedIn,isTveContent)
    if(isUnmatchedTvePlan) { // *this key specifies user is logged in with TVE and only TVE is applied on content
      setTveSubscribedError(true)
      publishAppLoading(false)
      return 
    }
    sessionStorage.setItem('current-associated-plans',JSON.stringify(plans)) //only to re-populate the subscription popup modal
    let servicetypes = handleSeviceTypes()
    if(videoData && !contentEntitlementPlans?.length) {
      let ids = formulateAllPlanIds(videoData)
      if(ids) {
        plans = await getPlansById(ids)
      }
    }
      let queryPlanId = getPlanIdFromQueryParams(window?.location?.href)
      if (queryPlanId) {
        if (queryPlanId === "TVE" || queryPlanId === "tve") {
          let tvePlan = tvePlanDetails({metadataMap,subscriptionPopupFonts})
          updateSelectedPlans(tvePlan, [], contentData)
          setPlans([tvePlan])
          handleTvePlanInsertion()
          return
        }
        if (props?.isCheckout){
        let plansRes = await getPlansById(queryPlanId,true) // isQueryPlanIds = true
        if (plansRes?.length) {
          let plan = structuredPlan(plansRes[0])
          plans = plansRes
          updateSelectedPlans(plan, plans, contentData)
          setPlans(plans)
          return 
        }}else {
          let Plans = contentPlans?.filter((plan => plan?.id === queryPlanId))
          if (Plans?.length) {
            let plan = structuredPlan(Plans[0])
            updateSelectedPlans(plan, contentPlans, contentData)
            setPlans(plans)
            return
          }
        }
      }else {
        if (props?.isCheckout) {
          if (servicetypes?.SVOD && !isTveRegistered()) { // svod service type check on checkout plans API call
            const contentPlanIds = sessionStorage.getItem('contentPlanIds')
            if(contentPlanIds !== "null"){
            let plansRes = (contentPlanIds && contentPlanIds != "svodAll") ? await getPlansById(contentPlanIds,false,true) : await getSubscriptionPlans()
            plans = plansRes
          }
          }
          handleTvePlanInsertion()
        }
      }
    if (plans?.length) {
      let currentSelectedPlan = fetchCurrentPlan()
      const isCurrentPlanAvailable = plans.filter(p=> p?.id === currentSelectedPlan?.planId || p?.id === currentSelectedPlan?.id) // comparision with id adds support for entitlement plans
      if (currentSelectedPlan && (!!isCurrentPlanAvailable.length || currentSelectedPlan?.type == "TVE")) updateSelectedPlans(currentSelectedPlan, plans, contentData) //stores the plan to session
      else {
        let structuredData = structuredPlan(plans[0],subscriptionPopupFonts)
        updateSelectedPlans(structuredData, plans, contentData)}
      setPlans(plans)
    } else {
          if(servicetypes?.TVE && isTveContent) {
            setIsTvePlan(true)
            publishAppLoading(false)
            return
          }
      // update the error wrapper with plans not available
      publishAppLoading(false)
      if(isTveRegistered() || !servicetypes?.SVOD || isTveContent) return
      publishErrorUpdate("Plans not available")
    }
  }
  catch(e) {
    console.log(e)
  }
  finally {
    setIsEntitlementDataFetched(true)
  }
  }
  const updateMonetizationCta = async (data) => {
    let subscriptionModal = {
      isOpen: false
    }
    // update plans
    if (data?.planId !== "FREE_LOGIN") {
      if (data) {
        if (!contentPlans) {
          // handling for checkout page
          let {plansDetail} = await fetchCheckoutStore()
          if (plansDetail?.allPlans) {
            contentPlans = plansDetail?.allPlans
          }
        }
        const plans = parseJSON(sessionStorage.getItem('current-associated-plans')) || contentPlans
        publishMorePurchaseList(subscriptionModal)
        updateSelectedPlans(data, contentPlans, contentData)
        publishMorePurchaseList(subscriptionModal)
        if(videoData) {
          let ids = formulateAllPlanIds(videoData)
          if(ids) {
            plans = await getPlansById(ids)
          }
        }
        setPlans(plans)
      }
    } else {
        // for non subscription events
        sessionStorage.setItem('currentPlan', JSON.stringify(data))
        publishPlansLoaded(false)
        setPlans([data])
    }
  }
  const updateContentPlans = (data) => {
    if(data?.length) {
      setContentEntitlementPlans(data)
    }else fetchPlans()
  }

  const fetchVideoDetails = async () => {
      let apiConfig = window?.app_data?.appcmsMain?.apiConfig
      let baseUrl = apiConfig?.entitlementBaseUrl  + "/video/status"
      let token = await getToken(token => {return token})
      let id = isSeriesPage ? videoData?.id : contentData?.gist?.id
      VLPlayerCore()?.getEntitlementData(id,token,baseUrl).then((res) => {
        let plans = e?.response?.plans
        if(plans?.length) setContentEntitlementPlans(plans)
        else fetchPlans()
      }).catch((e) => {
        let plans = e?.response?.data?.plans
        if(plans?.length) setContentEntitlementPlans(plans)
        else fetchPlans()
      })

  }
  useEffect(() => {
    subscribeUpdateMonetizationCta(updateMonetizationCta)
    subscribeGetContentEntitlementPlans(updateContentPlans)
    if(!isVideoPage && !isSeriesPage) {
      fetchPlans()
    }else { // if video or series detail page
      let freePreview =  window?.app_data?.appcmsMain?.features?.free_preview
      let isFreePreview = freePreview?.isFreePreview || false 
      if(!isFreePreview) { // call entitlement in case free preview is diabled
        fetchVideoDetails()
      }
    }
    return () => sessionStorage.removeItem('current-associated-plans')
  }, [])

  useEffect(() => {
    // to avoid multiple plans verifification and formulation in case of video detail page
    if(isVideoPage || isSeriesPage) {
      if(contentEntitlementPlans?.length) {
        isTveContent = contentEntitlementPlans?.filter((plan) => plan?.type === "TVE" || plan?.monetizationModel === "TVE")?.length ? true : false
        setIsTvePlan(isTveContent)
        fetchPlans()
      }
    }
  },[contentEntitlementPlans])

  return (<>
    <div className='plans-wrapper-container'>
      <div style={ctaHeadingStyles}>{props?.localisation?.getAccessText || metadataMap?.getAccessText}</div>
      <div onClick={() => {
        let plans = contentEntitlementPlans?.length ? contentEntitlementPlans : contentPlans
        let contentPlanIds = fromulatePlanIds(plans)
        let redirectingUrl = location?.pathname + location?.search 
        localforage.setItem("isRedirected", { path: redirectingUrl, redirect: true, isDetailPage: true, isCheckout : props?.isCheckout })
        if(contentPlanIds?.length) sessionStorage.setItem("contentPlanIds", contentPlanIds)
        publishRedirect(layoutSettings?.comparePlanPagePath)
        publishAppLoading(true)
        return
      }} className='compare-plans'>{props?.localisation?.comparePlansText}</div> 
    </div>
    {tveSubscribedError ? checkoutSettings?.notAuthorizeTVEText || "You are not authorize to watch this content with current TV provider" : <></>}
    {(plans?.length || isTvePlan) && isEntitlementDataFetched && !tveSubscribedError ? <PlansList featureListToShow={props?.featureListToShow} parentModuleData={props?.parentModuleData} isCheckout={props?.isCheckout} layoutSettings={layoutSettings} plans={plans} metadataMap={metadataMap} subscriptionPopupFonts={subscriptionPopupFonts} moneisationCta={moneisationCta} isTvePlan={isTvePlan} contentData={contentData} /> : <></>}
  </>)
}

export default PlansWrapper